export class Pair<A, B> {

    public readonly first: A;
    public readonly second: B;

    constructor(first: A, second: B) {
        this.first = first;
        this.second = second;
    }
}
